export default {
  appName: 'simaapp',
  apiEndpoint: 'https://data.sima-api.com',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config.js